<template>
  <div id="date"></div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { generateDateData } from '@/common/utils/module/FormattingSupport';
import { isEmpty } from '@/common/utils/Util';
const props = defineProps(['data']);
const emits = defineEmits(['close']);
const { fnCallBack, title, isDateTime } = props.data;

const date = ref();

onMounted(async () => {
  const elem = document.getElementById('date');
  const currentYear = new Date().getFullYear();
  const data = generateDateData(currentYear - 120, currentYear, isDateTime);

  new PickerView({
    bindElem: elem,
    data: data,
    title: title,
    leftText: '닫기',
    rightText: '선택',
    saveFn: function(selectArr) {
      if (isEmpty(selectArr)) {
        close();
        return;
      }
      if (!isDateTime) {
        date.value = selectArr.map(num => num.toString().padStart(2, '0')).join('-');
      } else {
        const [year, month, day, hour, minute] = selectArr.map(num => num.toString().padStart(2, '0'));
        date.value = `${year}-${month}-${day} ${hour}:${minute}`;
      }
      close();
    }
  });
});

const close = () => {
  const payload = {
    date: date.value
  };
  if (fnCallBack) fnCallBack(payload);
  setTimeout(() => {
    emits('close');
  }, 100);
};
</script>
<style scoped></style>
